import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import { Fade } from "@mui/material"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"

const VizitkaPage = () => {
  const navigate = useNavigate()

  useEffect(() => {
    logMessage("ВИЗИТКА")
    navigate("/", { replace: true })
  }, [navigate])

  return (
    <Fade timeout={timeout} in>
      <div className="pt-24 flex flex-col justify-between min-h-screen">
        <div className="text-3xl mb-10 text-[#002998ef]">VizitkaPage</div>
      </div>
    </Fade>
  )
}

export default VizitkaPage
